import firebase from "firebase/compat/app";
import React, { useState, useEffect } from "react";

import {
  CreateNewMessages,
  UpdateMessages,
  deleteMessages,
  getMessages,
} from "../Data/Messages";

import { FStorage, firebase_Db } from "../config/firebaseConfig";
import { duration } from "@material-ui/core";

const DBName = "messages";
function CreateMessage({ btnName, titleName, submitType, messagesData }) {
  const { data, id } = messagesData;
  const [Allmessages, setAllMessages] = useState({
    title: "",
    duration: "",
    reciver: "",
  });

  const [submit_type, setSubmitType] = useState(false);

  useEffect(() => {
    function checkSubmit() {
      if (submitType === "Create") {
        setSubmitType(true);
      } else {
        setSubmitType(false);
      }
    }
    return checkSubmit();
  }, [submitType]);

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setSubmitType(submitType);
    if (submit_type && Allmessages.title && Allmessages.duration) {
      const ref = firebase_Db.collection(DBName).doc();
      await firebase_Db
        .collection(DBName)
        .add({
          id: ref.id,
          title: Allmessages.title,
          duration: Allmessages.duration,
          receiverType: Allmessages.reciver,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          alert("message created");
          setAllMessages({
            title: "",
            duration: "",
            reciver: "",
          });
          
        })
        .catch(() => {
          alert("Message not created");
        });
    } else {
      await firebase_Db
        .collection(DBName)
        .doc(id)
        .update({
          id: id,
          title: Allmessages.title || data.title,
          duration: Allmessages.duration || data.duration,
        })
        .then(() => {
          alert("message updated");
          setAllMessages({
            title: "",
            duration: "",
          });
          setSubmitType("");
        })
        .catch(() => {
          alert("message was not able to updated");
        });
    }
  };

  return (
    <div className="holder">
      <form className="msgForm" onSubmit={handleOnSubmit}>
        <div className="title">
          <h4>{titleName}</h4>
        </div>
        <textarea
          id="textarea"
          placeholder="Enter Your Message Here"
          value={Allmessages.title}
          onChange={(e) =>
            setAllMessages((_) => {
              return { ...Allmessages, title: e.target.value };
            })
          }
        ></textarea>
        <input
          type="text"
          placeholder="Title"
          className="duration"
          value={Allmessages.duration}
          onChange={(e) =>
            setAllMessages((_) => {
              return { ...Allmessages, duration: e.target.value };
            })
          }
        />
        <input
        style={{width:"70%", margin: "5%", padding: "5px"}}
          type="text"
          placeholder="Enter recievers Email, or enter 'all' for all users"
          className="reciever"
          value={Allmessages.reciver}
          onChange={(e) =>
            setAllMessages((_) => {
              return { ...Allmessages, reciver: e.target.value };
            })
          }
        />
        <div className="formBtn">
          <button className="create-msg">{btnName}</button>
        </div>
      </form>
    </div>
  );
}

export default CreateMessage;
